module.exports = __webpack_public_path__ + "static/media/instant-offer-confirm.4bb6bdba.gif";